const riot = require('riot');

riot.tag2('atom-action-button', '<div class="py20 w-full rounded-4 f fh letter-spacing_0 fw6 text-white lh10 cursor-pointer {opts.negative ? &quot;bg-danger box-shadow-button-negative&quot; : &quot;bg-primary-light box-shadow-button&quot;}">{opts.text}</div>', '', '', function(opts) {
});